import { TemplateComponent } from './template/template.component';
import { TestComponent } from './test/test.component';
import { TriptychLineHorStepsComponent } from './triptych-line-hor-steps/triptych-line-hor-steps.component';
import { DemoAbnTriptychLineHorStepsComponent } from './demo-abn-triptych-line-hor-steps/demo-abn-triptych-line-hor-steps.component';
import { DemoBfsTriptychLineHorStepsComponent } from './demo-bfs-triptych-line-hor-steps/demo-bfs-triptych-line-hor-steps.component';
import { DemoDestatisTriptychLineHorStepsComponent } from './demo-destatis-triptych-bar-hor-steps/demo-destatis-triptych-bar-hor-steps.component';
import { DemoTilastokeskusTriptychLineHorStepsComponent } from './demo-tilastokeskus-triptych-line-hor-steps/demo-tilastokeskus-triptych-line-hor-steps.component';
import { DemoTilastokeskusLineComponent } from './demo-tilastokeskus-line/demo-tilastokeskus-line.component';
import { DemoDSTTriptychLineHorStepsComponent } from './demo-dst-triptych-line-hor-steps/demo-dst-triptych-line-hor-steps.component';
import { DemoRaboTriptychBarVertStepsComponent } from './demo-rabo-triptych-bar-vert-steps/demo-rabo-triptych-bar-vert-steps.component';
import { DemoRlpTriptychBarVertStepsComponent} from './demo-rlp-triptych-bar-vert-steps/demo-rlp-triptych-bar-vert-steps.component';
import { DemoStatbelTriptychBarComponent } from './demo-statbel-triptych-bar/demo-statbel-triptych-bar.component';
import { DemoStatistikamtnordTriptychBarHorStepsComponent } from './demo-statistikamtnord-triptych-bar-steps/demo-statistikamtnord-triptych-bar-hor-steps.component';
import { DemoSatTriptychLineHorStepsComponent } from './demo-sat-triptych-line-hor-steps/demo-sat-triptych-line-hor-steps.component';
import { DemoHessenTriptychLineHorStepsComponent } from './demo-hessen-triptych-line-hor-steps/demo-hessen-triptych-line-hor-steps.component';
import { DemoSCBTriptychLineHorStepsComponent } from './demo-scb-triptych-line-hor-steps/demo-scb-triptych-line-hor-steps.component';



// import { environment } from '../../environments/environment';
// import * as _ from 'lodash';

export let animations = {
  'plaatje': [ ],
  'social': [
    // {
    //   'id': 'template-social',
    //   'name': 'Template',
    //   'component': TemplateComponent,
    // },
    // {
    //   'id': 'triptych-line-hor-steps-social',
    //   'name': 'Drieluik CBS',
    //   'component': TriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'demo-abn-triptych-line-hor-steps-social',
    //   'name': 'Drieluik ABN-AMRO',
    //   'component':  DemoAbnTriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'demo-bfs-triptych-line-hor-steps-social',
    //   'name': 'Drieluik BfS',
    //   'component': DemoBfsTriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'demo-tilastokeskus-triptych-line-hor-steps-social',
    //   'name': 'Drieluik Tilastokeskus',
    //   'component': DemoTilastokeskusTriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'demo-tilastokeskus-line',
    //   'name': 'Linechart Tilastokeskus',
    //   'component': DemoTilastokeskusLineComponent,
    // },
    // {
    //   'id': 'demo-dst-triptych-line-hor-steps-social',
    //   'name': 'Drieluik DST',
    //   'component': DemoDSTTriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'test-social',
    //   'name': 'Test',
    //   'component': TestComponent,
    // },
    {
      'id': 'demo-destatis-triptych-bar-steps-social',
      'name': 'Beispiel Destatis',
      'component': DemoDestatisTriptychLineHorStepsComponent,
    },
    // {
    //   'id': 'demo-hessen-triptych-line-hor-steps-social',
    //   'name': 'Drieluik Hessen',
    //   'component': DemoHessenTriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'demo-rabo-triptych-bar-vert-steps-social',
    //   'name': 'Drieluik Rabobank',
    //   'component': DemoRaboTriptychBarVertStepsComponent,
    // },
    // {
    //   'id': 'demo-rlp-triptych-bar-vert-steps-social',
    //   'name': 'Drieluik RLP',
    //   'component': DemoRlpTriptychBarVertStepsComponent,
    // },
    // {
    //   'id': 'demo-statbel-triptych-bar-social',
    //   'name': 'Drieluik Statbel',
    //   'component': DemoStatbelTriptychBarComponent,
    // },
    // {
    //  'id': 'demo-statistikamtnord-triptych-bar-steps-social',
    //  'name': 'Drieluik StatistikamtNord',
    //  'component': DemoStatistikamtnordTriptychBarHorStepsComponent,
    // },
    // {
    //   'id': 'demo-sat-triptych-bar-steps-social',
    //   'name': 'Drieluik Statistics Austria',
    //   'component': DemoSatTriptychLineHorStepsComponent,
    // },
    // {
    //   'id': 'demo-scb-triptych-line-hor-steps-social',
    //   'name': 'Drieluik SCB',
    //   'component': DemoSCBTriptychLineHorStepsComponent,
    // },
  ],
  'video': [ ],
  'overig': [ ],
};



// WEBPACK FOOTER //
// ./src/app/animations/animations.ts